export type BlobMap = Record<string, Promise<Blob>>
